import { render } from "./BookWithUser.vue?vue&type=template&id=7798d854"
import script from "./BookWithUser.vue?vue&type=script&lang=js"
export * from "./BookWithUser.vue?vue&type=script&lang=js"

import exportComponent from "E:\\学习资料\\项目\\Vue-Springboot-Library-main\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__